<template>
  <div class="image-container" :style="width ? `--width: ${width}px;` : ''">
    <Picture
      class="d-none d-sm-block"
      :image-sizes="imageSizes"
      :url="image_desktop.url"
      :alt="image_desktop.alt"
    />
    <Picture
      class="d-block d-sm-none"
      :image-sizes="imageSizes"
      :url="mobileUrl"
      :alt="mobileAlt"
    />
  </div>
</template>

<script>
import Picture from 'UI/Picture';
export default {
  components: {
    Picture
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      width: 1114,
      image_desktop: {},
      image_mobile: {}
    };
  },
  computed: {
    imageSizes() {
      return [
        { resolution: 1800, size: 1800 },
        { resolution: 1540, size: 1799 },
        { resolution: 1200, size: 1539 },
        { resolution: 992, size: Math.min(1119, this.width) },
        { resolution: 768, size: Math.min(991, this.width) },
        { resolution: 576, size: Math.min(767, this.width) },
        { resolution: 450, size: Math.min(575, this.width) },
        { resolution: 375, size: 328 },
        { resolution: 0, size: 314 }
      ];
    },
    mobileUrl() {
      return this.image_mobile.url || this.image_desktop.url;
    },
    mobileAlt() {
      return this.image_mobile.alt || this.image_desktop.alt;
    }
  },
  created() {
    const sizes = [
      { key: 'medium', width: 900 },
      { key: 'small', width: 701 },
      { key: 'smallest', width: 500 }
    ];
    const { image_desktop, image_mobile, image_size } = this.slice.primary;
    this.image_desktop = image_desktop;
    this.image_mobile = image_mobile;

    const sizeFound = sizes.filter((size) => size.key === image_size);
    if (sizeFound.length) {
      this.width = sizeFound[0].width;
    }
  }
};
</script>

<style lang="scss" scoped>
.image-container {
  margin: 0 auto;
  max-width: var(--width);
}
</style>
